import { Box } from "@mui/material";
import React from "react";
import HeroPhone from "./HeroPhone";
import useBreakpoint from "../../../../hooks/useBreakpoint";

export default function HeroImage({ src, alt, map, catalogue }) {
  const breakpoint = useBreakpoint();
  return (
    <Box
      className={`relative flex-1 sm:h-[250px] lg:h-[350px] flex flex-col w-full`}
    >
      <Box className="sm:h-[150px] lg:h-[250px] rounded-[55px] lg:w-[55%] md:w-[65%] self-center ">
        <HeroPhone />
      </Box>
      <img
        src={catalogue}
        alt={"zoomed catalogue"}
        width={["xl", "lg"].includes(breakpoint) ? 180 : 110}
        className="absolute lg:-bottom-[30px] bottom-[6px] -left-[6px] md:-left-[24px] lg:left-[8px] object-contain transition-all duration-1000 transform hover:scale-105 z-[2] animate-grow"
      />
      <img
        src={map}
        alt={"zoomed map"}
        width={["xl", "lg"].includes(breakpoint) ? 180 : 110}
        className="absolute top-[40px] lg:right-[60px] md:right-[10px] right-[34px] object-contain transition-all duration-1000 transform hover:scale-105 z-[2] animate-grow"
      />
      {/* <img
        src={map}
        alt={"zoomed map"}
        width={180}
        className="absolute transform translate-y-1/4 right-[60px] object-contain transition-all duration-1000 transform hover:scale-105 z-[2]"
      /> */}
    </Box>
  );
}
